const app = angular.module('msi.forms.formField', []);

app.directive('ogFormfield', require('./form-field'));
app.directive('ngRequired', require('./ng-required'));
app.directive('ngDisabled', require('./ng-disabled'));
app.directive('name', require('./control-name'));
app.directive('ogElementReady', require('./element-ready'));
app.directive('ogSetFocus', require('./set-focus'));
app.directive('ogFocusOnError', require('./focus-on-error'));

module.exports = app.name;
